(function () {
    let lastMegaMenuItem = 0;

    let openMainMenu = function (evt) {
        let targetSelector = $(evt.target).data('selector');
        if (!$(targetSelector).hasClass('open')) { //prevent toggle off self
            $(targetSelector).siblings().removeClass('open');
            $(targetSelector).toggleClass('open');
            $(evt.target).attr('aria-expanded', 'true');
            $(targetSelector).find('img').each( (key,imgitem) => {
                if(! $(imgitem).attr('src') && $(imgitem).data('imgsrc')) {
                    let imgsrc = $(imgitem).data('imgsrc');
                    $(imgitem).attr('src',imgsrc);
                }
            });

        }
    };

    let closeMainMenu = function (evt) {
        let targetSelector = evt.toElement || evt.relatedTarget;
        if (!$(targetSelector).parents().hasClass('submenu')) {
            $('#header .submenu').removeClass('open');
            $(evt.target).find('.desktop-menu-button').attr('aria-expanded', 'false');
        }
    };

    let setMegaMenuTabIndex = function (parentSelector) {
        //reset all megaamenu tabindex
        $('.submenu.desktop-menu-content a').each(function (index, element) {
            element.setAttribute('tabindex', -1);
        });
        //set active mega-menu items tabindex
        $(parentSelector).find('a:visible').each(function (index, element) {
            element.setAttribute('tabindex', (index + 1));
            lastMegaMenuItem = index + 1;
        });
    }
    let focusOnParentButton = function (evt) {
        let megamenuButtonId = '#' + $(evt.target).parents('.mega-menu').attr('id') + 'Button';
        $(megamenuButtonId).focus();

    };

    let focusOnParentNextSibling = function (evt) {
        let megamenuButtonId = '#' + $(evt.target).parents('.mega-menu').attr('id') + 'Button';
        $(megamenuButtonId).next().focus();
        closeMainMenu(evt);

    };

    /* mainMenu interactions */
    $(document).on('mouseover', '#desktop-menu .desktop-menu-button', function (evt) {
        openMainMenu(evt);

    });

    $(document).on('mouseleave', '.submenu', function () {
        $(this).removeClass('open');
        $('.desktop-menu-button').attr('aria-expanded', 'false');
    });

    $(document).on('mouseleave', '#desktop-menu', function (evt) {
        closeMainMenu(evt);

    });


    //mobile-menu-icon
    $(document).on('click', '.mobile-menu-icon', function (evt) {
        $('.mega-menu').find('img').each( (key,imgitem) => {
            if(! $(imgitem).attr('src') && $(imgitem).data('imgsrc')) {
                let imgsrc = $(imgitem).data('imgsrc');
                $(imgitem).attr('src',imgsrc);
            }
        });

    });

    //handle keypress on main-menu top buttons
    $(document).on('keydown', '#desktop-menu .desktop-menu-button', function (evt) {
        let targetSelector = '';
        switch (evt.key) {
            case 'ArrowDown':
                evt.preventDefault();
                openMainMenu(evt);
                targetSelector = $(evt.target).data('selector');
                setMegaMenuTabIndex(targetSelector);
                $(targetSelector).find('a').first().focus();
                break;
            case 'ArrowUp':
                evt.preventDefault();
                break;
            case 'Enter':
                targetSelector = $(this).data('selector');
                if ($(targetSelector).hasClass('open')) {
                    $(targetSelector).removeClass('open');
                    $(this).attr('aria-expanded', 'false');
                } else {
                    $(targetSelector).siblings().removeClass('open');
                    $(targetSelector).addClass('open');
                    $(this).attr('aria-expanded', 'true');
                    setMegaMenuTabIndex(targetSelector);

                }
                break;
            case 'Escape':
            case 'Tab':
                closeMainMenu(evt);
                break;
        }
    });

    //handle keypress on mega-menu inner content
    $(document).on('keydown', '.mega-menu a', function (evt) {
        let tabindex = 0;
        switch (evt.key) {
            case 'ArrowDown':
                evt.preventDefault();
                tabindex = parseInt($(evt.target).attr('tabindex'));

                if (tabindex == lastMegaMenuItem) {
                    focusOnParentNextSibling(evt);
                } else {
                    $('[tabindex=' + (tabindex + 1) + ']').focus();
                }

                break;
            case 'ArrowUp':
                evt.preventDefault();
                tabindex = parseInt($(evt.target).attr('tabindex'));
                if (tabindex == 1) {
                    focusOnParentButton(evt);
                } else {
                    $('[tabindex=' + (tabindex - 1) + ']').focus();
                }

                break;

            case 'Escape':
                focusOnParentButton(evt);
                closeMainMenu(evt);//not gonna work. not the same at the parent context
                break;
        }
    });

    //mobile keyboard
    const myOffcanvas = document.getElementById('offcanvasNavbar')
    myOffcanvas?.addEventListener?.('shown.bs.offcanvas', event => {
        let index = 1;
        $('.main-menu-wrapper li.submenu-toggle:visible, .main-menu-wrapper li a:visible').each(function (index, element) {
            element.setAttribute('tabindex', (index + 1));
            lastMegaMenuItem = index + 1;
        });

    });

    /* open mobile sub-menu accordion  on Enter */
    $(document).on('keydown', '.submenu-toggle', function (evt) {
        let tabindex = parseInt($(evt.target).attr('tabindex'));
        switch (evt.key) {
            case 'Enter':
                $(evt.target).click();
                break;
        }
    });

    /* mobile sub-menu back one level on left-arrow */
    $(document).on('keydown', '.submenu.show, .submenu.show *', function (evt) {
        switch (evt.key) {
            case 'ArrowLeft':
                $('#header .submenu.show').find('.submenu-title').click();
                break;
        }
    });

    /* close mega-menu on clicking external link */
    $(document).on('click','.mega-menu a', function(evt){
        if(typeof $(this).attr('target') == 'string') {
            closeMainMenu(evt);
        }
    });

    /* Resize desktop main menu to fit client */
    let debouncedResize = _.throttle(function () {
        let menuHeight = ($(window).outerHeight() - 200) + 'px';  //200 is header height + bottom buffer
        let menuWidth = ($(window).innerWidth() > 775 && $(window).innerWidth() < (1160 + 80) ? $(window).innerWidth() - 80 : 1160) + 'px'; /*1160 is max width, 80 is combined margins*/
        $('.desktop-menu-content').css('max-width', menuWidth);
        $('.desktop-menu-content .mega-menu').css('max-height', menuHeight);

    }, 50, {leading: true, trailing: false});

    $(window).on('resize', function () {
        debouncedResize();
    });
    debouncedResize();

}());
